import React from 'react';

import { moneyShort, pct } from './logic';
import { tcc } from './palette';

export default function ChartValueLabel({
  x,
  y,
  width,
  height,
  value,
  kind = 'current',
  format = 'percent',
}: {
  x?: number;
  y?: number;
  width?: number;
  height?: number;
  value?: unknown;
  kind?: 'current' | 'predicted';
  format?: 'percent' | 'ratio' | 'money';
}) {
  if (typeof value !== 'number' || value === 0 || x == null || y == null || width == null || height == null)
    return null;
  const label = format === 'money' ? moneyShort(value) : format === 'ratio' ? pct(value) : `${Math.round(value)}%`;
  return (
    <text
      className="recharts-label"
      data-chart-value-label
      data-kind={kind}
      data-bar-x={x}
      data-bar-y={y}
      data-bar-width={width}
      data-bar-height={height}
      data-value={value}
      data-outside-fill={kind === 'current' ? tcc.bookedText : tcc.predictedText}
      x={x + width / 2}
      y={y - 8}
      textAnchor="middle"
      dominantBaseline="middle"
      fontSize={10}
      fill={kind === 'current' ? tcc.bookedText : tcc.predictedText}
    >
      {label}
    </text>
  );
}
